const SCREEN = {
  ACCOUNT: 'Account',
  SIGNIN_INFO: 'LogIn Info',
  USER_INFO: 'User Info',
  EMAIL_RESET_FORM: 'Email Reset Form',
  PHONE_RESET_FORM: 'Phone Reset Form',
  PLEASE_CHECK_EMAIL: 'Please Check Email',
};

const ITEM = {
  SIGNIN_INFO: 'LogIn Info',
  USER_INFO: 'User Info',
  SETTLEMENT_INFO: 'Settlement Info',
  APPLICATION_SETTINGS: 'Application Settings',
  HELP: 'Help = FAQ',
  TERMS_AND_CONDITIONS: 'T&C',
  APPLY_FOR_AUTO_DEBIT: 'Apply for Auto Debit',
  CHANGE_TO_AUTO_DEBIT: 'Change to Auto Debit',
  CHANGE_TO_COMBINI: 'Change to Combini',
  UNREGISTER_BANK: 'Unregister Bank',
  NEXT: 'Next',
  SUPPORTED_BANKS: 'Supported Banks',
  SUBMIT: 'Submit',
};

const ACTION = {
  PAGE_VIEW: 'Page View',
  CLICK: 'Click',
};

const ORIGIN = {
  LOGIN: 'Login',
  ACCOUNT: 'Account',
};

const SCREEN_TYPE = {
  EMAIL_RESET: 'Email Reset',
  PHONE_RESET: 'Phone Reset',
};

export { ACTION, ITEM, ORIGIN, SCREEN, SCREEN_TYPE };
